import { IAttribute, IModel } from './../base/annotation';
import { Metamodel } from '../base/model';
import { LinkedService } from './linkedservice';
import { AzureKeyVault } from './key-vault';
import { format, getConnectorV1Name } from '../../shared/utils/string.util';
import { ModelConstants } from '../model-constants';
import { isTridentInIframe } from '../../shared/utils/iframe.utils';
import { validateAKVLinkedServiceReference } from '../../shared/utils/linkedservice-validation-util';
import { shellStringResources } from '../../Resources/ShellStringResources';

@Metamodel.model({
    name: ModelConstants.salesforceLinkedService,
    disabled: isTridentInIframe(),
    display: [
        format(shellStringResources.ModelName_LinkedServiceTemplate,
            getConnectorV1Name(shellStringResources.Salesforce_DisplayText)),
        format(shellStringResources.ModelName_LinkedServicesTemplate,
            getConnectorV1Name(shellStringResources.Salesforce_DisplayText))
    ]
})
export class SalesforceLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    public static readonly ENVIRONMENT_URL: IAttribute;
    public static readonly USER_NAME: IAttribute;
    public static readonly API_VERSION: IAttribute;
    public static readonly PASSWORD: IAttribute;
    public static readonly SECURITY_TOKEN: IAttribute;
    
    public isLegacyConnector = true;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_EnvironmentUrl,
        association: 'ENVIRONMENT_URL',
        templatable: true
    })
    public environmentUrl?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_UserName,
        association: 'USER_NAME',
        templatable: true
    })
    public userName?: string;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_Password,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'PASSWORD',
        templatable: true
    })
    public password?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SecurityToken,
        constraint: {
            validator: validateAKVLinkedServiceReference
        },
        association: 'SECURITY_TOKEN',
        templatable: true
    })
    public securityToken?: string | AzureKeyVault;

    @Metamodel.attribute({
        display: shellStringResources.ModelName_SalesforceApiVersion,
        association: 'API_VERSION',
        templatable: true
    })
    public apiVersion?: string;

    constructor(name?: string, description?: string) {
        super(name, description);
    }

    public editingErrorMessageCustomizer(): string {
        return this.apiVersion === 'Default' ? shellStringResources.Api_Version_Not_SupportDefault : '';
    }
}
